import { CROSS_BREAKPOINT, LARGE } from './breakpoint-controller'

var el, listening = false;

function onDocumentReady(){
	el = $('.filter-bar');
	if(el.length > 0){
		$(document).on(CROSS_BREAKPOINT, onCrossBreakpoint);
	}
}

function onCrossBreakpoint(e, breakpoint){
	if(breakpoint >= LARGE){
		ignoreEvents();
	} else {
		listenForEvents();
	}
}

function listenForEvents(){
	if(!listening){
		el.on('click', '.title', onClickFilterBy);
		el.on('click', '.dropdown-label', onClickDropdownLabel);
		listening = true;
	}
}

function ignoreEvents(){
	if(listening){
		el.off('click', '.title', onClickFilterBy);
		el.off('click', '.dropdown-label', onClickDropdownLabel);
		el.find('.dropdown-menu,.options').removeAttr('style');
		listening = false;
	}
}

function onClickDropdownLabel(e){
	var clicked = $(e.currentTarget);
	var dropdown = clicked.closest('.dropdown-menu');
	dropdown.toggleClass('active');
	dropdown.find('.options').slideToggle();

	e.stopImmediatePropagation();
	return false;
}

function onClickFilterBy(e){
	el.find('.dropdown-menu').slideToggle();
	e.stopImmediatePropagation();
	return false;
}

document.addEventListener('DOMContentLoaded', onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/mobile-filter-bar-controller.js